<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/property/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/material/property/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('wuliaoshuxing')" required>
            <yi_dictionary_select :type="'CUSTOMER_MATERIAL_PROPERTY_TYPE'" :ids.sync="yt.editObj.code"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shuxingzhi')" required>
            <yi_dictionary_select :type="'CUSTOMER_MATERIAL_PROPERTY_VALUE'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/property/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('wuliaoshuxing')" class="noborder" required>
            <el-input disabled v-model="yt.editObj.code"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('shuxingzhi')" required>
            <yi_dictionary_select :type="'CUSTOMER_MATERIAL_PROPERTY_VALUE'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/property/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_base_matter_matter_material',
  data() {
    return {
      columns: [
        {
          label: 'wuliaoshuxing',
          prop: 'code'
        },
        {
          label: 'shuxingzhi',
          prop: 'value',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_PROPERTY_VALUE'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 120
        }
      ]
    };
  },
  watch: {
    'yt.editObj.code'(value) {
      if (value) {
        this.$set(this.yt.editObj, 'code', this.$t('yanse'));
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 100
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300);
  },
  methods: {
    beforeAdd(params, url) {
      params.materialId = this.$attrs.material.id;
      return params;
    }
  }
};
</script>

<style scoped lang="scss"></style>
